import $ from 'jquery';
const Faq = function () {
  $(window).on('load', () => {
    {
      const el = document.getElementById('js-floatIndex');
      const area = document.getElementById('js-observeArea');
      const options = {
        threshold: 1
      }
      const cb = (entries) => {
        entries.forEach(entry => {
          // ビューポート上部に到達したらクラス付与してCSSにて調整
          if (!entry.isIntersecting) {
            $(el).addClass('is-fixed');
          } else {
            $(el).removeClass('is-fixed');
          }
        });
      }
      const observer = new IntersectionObserver(cb, options);
      observer.observe(area);
    }
    {
      const el = document.getElementById('js-floatIndex');
      const target = document.querySelector('.l-footer');
      const options = {
        threshold: 0.2
      }
      const cb = (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            $(el).addClass('is-sticky');
          } else {
            $(el).removeClass('is-sticky');
          }
        });
      }
      const observer = new IntersectionObserver(cb, options);
      observer.observe(target);
    }

    // Current Btn
    {
      const targets = document.querySelectorAll('.js-target');
      const options = {
        rootMargin: "-50% 0px", // ビューポートの中心を判定基準にする
        threshold: 0
      }
      const cb = (entries) => {
        entries.forEach(entry => {
          // 引っかかったらクラス付与
          if (entry.isIntersecting) {
            $(`a[data-faq]`).removeClass('current');
            let data = entry.target.getAttribute('data-faq');
            document.querySelector(`a[data-faq="${data}"]`).classList.add('current');
          }
        });
      }
      const observer = new IntersectionObserver(cb, options);
      targets.forEach(target => { observer.observe(target) });
    }
  });
}

export default Faq;


// WEBPACK FOOTER //
// ./src/recruit/js/faq.js